import { createContext } from "react";

export const JobStatusContext = createContext();
